import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ApiService } from '../services/api.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  public loginForm: FormGroup;
  public sessionExpired: boolean = false;
  public error: boolean = false;

  constructor(private formBuilder: FormBuilder, private apiService: ApiService, private router: Router) {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
      strategy: ['local']
    });

  }

  ngOnInit() {
    this.sessionExpired = (localStorage.getItem('sessionExpired') == 'true');
  }

  submitLoginForm() {
    this.apiService.authenticate(this.loginForm.value).then((token) => {

      localStorage.setItem("email", this.loginForm.value.email);

      if(localStorage.getItem("email") == 'tv@uncan.ax') {
        this.router.navigateByUrl('visitors');
      } else {
        this.router.navigateByUrl('checkin');
      }

    }, (err) => {
      this.error = true;
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts